import { memo, useMemo } from 'react'
import { CallPutType, MultiStrikeChartTypes } from '../../../../reducer/multiStrikeChart.reducer'
import SeriesOptionMetadataDisplay from './seriesOptionMetadataDisplay'

type Props = {
    viewKey: string
    strike: string
    callKey?: string
    putKey?: string
    callSeriesColor?: string
    putSeriesColor?: string
    callPut?: CallPutType[]
    chartType: MultiStrikeChartTypes
}

const MultiStrikeStrikeMetadataRow = ({
    viewKey,
    strike,
    callKey,
    putKey,
    callSeriesColor,
    putSeriesColor,
    callPut,
    chartType,
}: Props) => {
    const callPutStable = useMemo(() => callPut ?? ['CE', 'PE'], [callPut])

    return (
        <SeriesOptionMetadataDisplay
            strike={strike}
            viewKey={viewKey}
            callSeriesColor={callSeriesColor}
            putSeriesColor={putSeriesColor}
            callKey={callKey}
            putKey={putKey}
            callPut={callPutStable}
            chartType={chartType}
        />
    )
}

export default memo(MultiStrikeStrikeMetadataRow, (prev, next) => {
    const prevCallPut = prev.callPut?.join(',') ?? ''
    const nextCallPut = next.callPut?.join(',') ?? ''
    return (
        prev.viewKey === next.viewKey &&
        prev.strike === next.strike &&
        prev.callKey === next.callKey &&
        prev.putKey === next.putKey &&
        prev.chartType === next.chartType &&
        prev.callSeriesColor === next.callSeriesColor &&
        prev.putSeriesColor === next.putSeriesColor &&
        prevCallPut === nextCallPut
    )
})
